import { Attributes, Misc, ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';
import Entity from './Entity';

@NeoModel
export default class EntityInvestorInvestmentDocument extends ModelBase {
    static typeName = "EntityInvestorInvestmentDocument";

    public entityInvestorInvestmentDocumentId: number = 0;

    @Attributes.Serialisation(Misc.SerialiseType.NotNull)
    public entityId: number | null = null;

    @Attributes.Parent(() => Entity)
    public entity: Entity | null = null;

    @Rules.Required()
    public documentTypeId: number | null = null;

    @Attributes.Display("Mandatory?")
    public isMandatory: boolean = false;

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew) {
            return "New entity investor investment document";
        } else {
            return "Entity Investor Investment Document";
        }
    }
}